
<template>
  <div>
    <label class="text-sm opacity-75">{{ $t('filters.' + filter.title + '.title') }}</label>
    <v-select color="success" multiple label="label" v-model="selected" :reduce="terms => terms.value" :options="filter.terms">
      <template v-slot:option="term">
        <span v-if="term.translate" :class="{'text-primary':isSelected(term)}">{{$t('filters.' + filter.title + '.values.' + term.label)}}</span>
        <span v-else :class="{'text-primary':isSelected(term)}">{{term.label}}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'sm-hateoas-filter-terms-select',
  components: {
    vSelect
  },
  props: {
    filter: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          terms: []
        };
      }
    }
  },
  data () {
    return {
      selected: this.filter.terms.filter(t => t.selected).map(t => t.value)
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler (value) {
        this.$emit('change', value);
      }
    }
  },
  methods: {
    isSelected (term) {
      return this.selected.indexOf(term.value) >= 0;
    }
  }
};
</script>

<style scoped>

</style>
